import FacilitiesService from '../../api/services/FacilitiesService';
import { beginApiCall, apiCallError } from './apiStatusActions';

export const LOAD_FACILITIES_SUCCESS = "LOAD_FACILITIES_SUCCESS";

function loadFacilitiesSuccess(facilities) {
    return { type: LOAD_FACILITIES_SUCCESS, facilities };
}

export function loadFacilities(projectId) {
    return function(dispatch) {
        dispatch(beginApiCall());

        return FacilitiesService.getFacilities(projectId)
            .then(facilities => {
                dispatch(loadFacilitiesSuccess(facilities));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}